import axios from 'axios'

import http from 'legacy/utils/http'
import requests, { getHeadersDocs } from 'legacy/utils/requests'

export function getCarrier() {
  return axios.get('/api/v2/carrier/', http.getHeadersV2())
}
export function getIntegrations() {
  return axios.get('/api/v2/carrier/integrations/', http.getHeadersV2())
}
export function updatePreference(data) {
  return axios.patch('/api/v2/carrier/', data, http.getHeadersV2())
}

// Third Party Integrations
export function getIntegrationRequests(status) {
  return requests.get(`/api/v2/integration-requests?status=${status}`)
}
export function acceptIntegrationRequest(id) {
  return requests.post(`/api/v2/integration-requests/${id}/accept/`)
}
export function rejectIntegrationRequest(id) {
  return requests.post(`/api/v2/integration-requests/${id}/reject/`)
}
export function denyIntegrationRequest(id) {
  return requests.post(`/api/v2/integration-requests/${id}/deny/`)
}

// Driver
export function getDriver(id) {
  return requests.get(`/api/v2/carrier/drivers/${id}`)
}
export function getDrivers() {
  return axios.get('/api/v2/carrier/drivers?limit=50', http.getHeadersV2())
}
export function createDriver(driver) {
  return requests.post('/api/v2/carrier/drivers', JSON.stringify(driver))
}
export function updateDriver(data) {
  return requests.put(`/api/v2/carrier/drivers/${data.id}`, JSON.stringify(data))
}

// Dispatcher
export function createDispatcher(dispatcher) {
  return requests.post('/api/v2/carrier/dispatchers', JSON.stringify(dispatcher))
}

// Docs
export function uploadCarrierDocument(data) {
  return getHeadersDocs().post('/api/v2/carrier/documents', data)
}
